import React from "react";

function Logo({ width, height, ...props }) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 192 192"
      width={width}
      height={height}
      {...props}
    >
      <path d="M96,0C42.98,0,0,42.98,0,96s42.98,96,96,96,96-42.98,96-96S149.03,0,96,0ZM69.93,126.57c-6.65,0-14.78-2.4-20.41-9.89l8.96-9.88c3.42,3.88,7.21,6.09,10.89,6.09,5.18,0,8.04-2.03,8.04-9.61v-24.56h-22.81v-13.3h38.7v39.16c0,12.01-6.09,21.98-23.36,21.98ZM137.08,104.59c0,12.01-6.09,21.98-23.36,21.98-6.65,0-14.78-2.4-20.41-9.89l8.96-9.88c3.42,3.88,7.21,6.09,10.89,6.09,5.18,0,8.04-2.03,8.04-9.61v-24.56h-22.81v-13.3h38.7v39.16Z" fill="#00d4ff" />
    </svg>
  );
}

export default Logo;
